import constants from './constants';

// only vehicles inside
const initState = {};

function socketReducer(state = initState, { type, payload }) {

  switch (type) {

    case constants.SOCKET_UPDATE_VEHICLE:
    case constants.SOCKET_UPDATE_ALL_VEHICLES:
      return {
        ...state,
        ...payload,
      };

    default:
      return state;

  }

}

export default socketReducer;
